import { useState } from "react";
import { Link, Navigate, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useCustomer } from "@/context/CustomerContext";
import { errMsg } from "@/lib/api";
import { inputCls, btnPrimary } from "@/lib/labels";
import { AuthShell, FormError } from "@/components/account/AuthShell";
import { PasswordInput, Field } from "@/components/account/PasswordInput";

export default function Login() {
  const { customer, login } = useCustomer();
  const [params] = useSearchParams();
  const next = params.get("next") || "/account";
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (customer) return <Navigate to={next} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav(next);
    } catch (err) {
      setError(errMsg(err, "مش قادرين نسجل دخولك"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell title="سجل دخول" subtitle="ادخل حسابك عشان تطلب إعلانك وتتابع شغلك ومحفظتك." testId="customer-login-page">
      <form onSubmit={submit} className="space-y-4" data-testid="customer-login-form">
        <Field label="الإيميل">
          <input type="email" dir="ltr" autoComplete="username" className={`${inputCls} text-right`} value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email-input" />
        </Field>
        <Field label="كلمة السر">
          <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} testId="login-password-input" />
        </Field>
        <FormError msg={error} />
        <button type="submit" disabled={busy} className={`${btnPrimary} w-full`} data-testid="login-submit-btn">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} دخول
        </button>
        <div className="flex flex-wrap justify-between gap-2 text-sm">
          <Link to="/forgot-password" className="text-[var(--km-lilac)] underline" data-testid="forgot-password-link">نسيت كلمة السر؟</Link>
          <Link to={`/register?next=${encodeURIComponent(next)}`} className="font-bold text-white underline" data-testid="go-register-link">معندكش حساب؟ اعمل حساب</Link>
        </div>
      </form>
    </AuthShell>
  );
}
